import { PHONE_NUMBERS } from "@/lib/constants";

export type PricingCountry = "inr" | "usd";

export const EXPERT_WHATSAPP_MESSAGE =
	"Hey TheHighraysYT, I want help choosing the right YouTube campaign package.";

export function normalizePricingCountry(
	country: string | null | undefined,
): PricingCountry {
	return country === "inr" ? "inr" : "usd";
}

export async function getCloudflareTracePricingCountry(
	signal?: AbortSignal,
): Promise<PricingCountry | null> {
	if (typeof fetch !== "function") return null;

	try {
		const response = await fetch("/cdn-cgi/trace", {
			cache: "no-store",
			headers: { accept: "text/plain" },
			signal,
		});
		if (!response.ok) return null;

		const country = /^loc=([A-Z]{2})$/m.exec(await response.text())?.[1];
		if (!country) return null;
		return country === "IN" ? "inr" : "usd";
	} catch {
		return null;
	}
}

export function getExpertWhatsAppPhone(country: string | null | undefined) {
	return normalizePricingCountry(country) === "inr"
		? PHONE_NUMBERS.india
		: PHONE_NUMBERS.canada;
}

export function buildExpertWhatsAppHref(
	country: string | null | undefined,
	message = EXPERT_WHATSAPP_MESSAGE,
) {
	const phone = getExpertWhatsAppPhone(country).replace(/\D/g, "");
	return `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
}
